require('./angular');
module.exports = angular;



//////////////////
// WEBPACK FOOTER
// ./node_modules/angular/index.js
// module id = /jXN
// module chunks = 0